module.exports = "query epayProducts {\n  epayProducts {\n    id\n    name\n    price\n    min_price\n    max_price\n    ean\n    tax\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/EpayProducts.graphql
// module id = N5ee
// module chunks = 1624